import { IndexContainer, IndexHeader, CardGrid, IndexCard } from '../../../styles/global'

export function SteelIndex() {
  const gradient = 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)'
  const accentColor = '#2c3e50'

  const calculators = [
    {
      title: 'Compressão em perfil laminado',
      description: 'Verificação de flambagem global e local em perfis laminados sob compressão',
      path: '/aco/laminado-compressao',
      icon: '🏗️',
      popular: true,
    },
    {
      title: 'Flexão em perfil laminado',
      description: 'Verificação de FLT, FLA e FLM em perfis laminados',
      path: '/aco/laminado-flexao',
      icon: '📐',
      popular: true,
    },
    {
      title: 'Solda para axiais',
      description: 'Verificação de soldas submetidas a esforços axiais centrados em estruturas metálicas',
      path: '/aco/solda-axial',
      icon: '⚡',
      popular: false,
    },
    {
      title: 'Base rotulada',
      description: 'Dimensionamento da chapa de base e dos chumbadores de pilares metálicos',
      path: '/aco/base-rotulada',
      icon: '🔩',
      popular: false,
    },
    {
      title: 'Compressão perfil formado à frio',
      description: 'Dimensionamento de perfis formados à frio sob compressão',
      path: '/aco/compressao-frio',
      icon: '❄️',
      popular: false,
    },
    {
      title: 'Flexão perfil formado à frio',
      description: 'Dimensionamento de perfis formados à frio sob flexão simples pelo Método das Seções Efetivas',
      path: '/aco/flexao-frio',
      icon: '❄️',
      popular: false,
    },
    {
      title: 'Chapa de piso',
      description:
        'Dimensionamento de chapas de piso em aço com verificação por deformação, resistência e peso próprio',
      path: '/aco/chapa',
      icon: '🟫',
      popular: false,
    },
    {
      title: 'Tubo circular à flexão',
      description: 'Dimensionamento e verificação de seções tubulares circulares sob momento fletor',
      path: '/aco/tubo-circular-flexao',
      icon: '⭕',
      popular: false,
    },
  ]

  return (
    <IndexContainer>
      <IndexHeader $gradient={gradient}>
        <div className="header-content">
          <h1>🔩 Estruturas Metálicas</h1>
          <p className="subtitle">
            Ferramentas completas para dimensionamento e verificação de elementos estruturais em aço
          </p>
          <div className="stats">
            <div className="stat-item">
              <span className="stat-number">{calculators.length}</span>
              <span className="stat-label">Calculadoras</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{calculators.filter((c) => c.popular).length}</span>
              <span className="stat-label">Mais Usadas</span>
            </div>
          </div>
        </div>
      </IndexHeader>

      <div className="content-wrapper">
        <h2>Calculadoras Disponíveis</h2>
        <CardGrid>
          {calculators.map((calc, index) => (
            <IndexCard
              key={index}
              to={calc.path}
              $popular={calc.popular}
              $gradient={gradient}
              $accentColor={accentColor}
            >
              {calc.popular && <span className="popular-badge">Popular</span>}
              <span className="card-icon">{calc.icon}</span>
              <h3>{calc.title}</h3>
              <p>{calc.description}</p>
              <span className="arrow">→</span>
            </IndexCard>
          ))}
        </CardGrid>
      </div>
    </IndexContainer>
  )
}
